import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthenticationStateManager";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user, authLoading } = useAuth();

  if (authLoading) {
    return null; // or spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/authentication-portal" replace />;
  }

  if (
    allowedRoles &&
    !allowedRoles.includes(user?.role?.toUpperCase())
  ) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;